// src/components/dashboard/table-planner/GuestCard.jsx
import React from "react";

export default function GuestCard({
  guest,
  onDragStart,
  onDragEnd,
  isSelected,
  onSelect,
}) {
  const cardClasses = isSelected
    ? "ring-2 ring-blue-500 ring-offset-2" // Style for selected state
    : "shadow-sm";

  return (
    <div
      draggable
      onDragStart={(e) => onDragStart(e, guest)}
      onDragEnd={onDragEnd}
      onClick={() => onSelect(guest)} // Handle tap/click
      className={`p-3 bg-white rounded-lg cursor-pointer flex justify-between items-center transition-shadow ${cardClasses}`}
    >
      <div>
        <div className="flex items-center gap-2 mb-1">
          <p className="font-bold text-gray-800">{guest.guestName}</p>
          <span
            className={`px-2 py-0.5 text-xs font-semibold rounded-full capitalize ${
              guest.invitedBy === "groom"
                ? "bg-blue-100 text-blue-800"
                : guest.invitedBy === "bride"
                ? "bg-pink-100 text-pink-800"
                : "bg-gray-100 text-gray-800"
            }`}
          >
            {guest.invitedBy || "Guest"}
          </span>
        </div>
        <div className="flex items-center text-sm text-gray-500">
          <span>Pax: {guest.pax}</span>
          {guest.isVegetarian && (
            <span className="ml-3" title="Vegetarian">
              🌿
            </span>
          )}
          {Number(guest.babyChairCount) > 0 && (
            <span
              className="ml-3"
              title={`${guest.babyChairCount} Baby Chair(s)`}
            >
              🍼
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
